import React from 'react'
import Layout from '../../components/LayoutNew'
import { graphql, useStaticQuery } from 'gatsby'
import HomeSection3 from '../../containers/HomeSection3'
import ProductSection1 from '../../containers/ProductSection1'
import ProductSection2 from '../../containers/ProductSection2'
import Img from 'gatsby-image'

import './marketing.scss'

const MarketingPage = () => {
  const pageColor = '#FFC210'
  const { marketing0, marketing1, marketing2 } = useStaticQuery(graphql`
    query {
      marketing0: file(
        relativePath: { eq: "products/marketing/marketing-0.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 568, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      marketing1: file(
        relativePath: { eq: "products/marketing/marketing-1.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 618, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      marketing2: file(
        relativePath: { eq: "products/marketing/marketing-2.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 470, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Layout
      className="marketing-page"
      headerBackground={pageColor}
      headerTheme="white"
    >
      <ProductSection1
        className="section-0"
        background={pageColor}
        title="共建本地生态，共赢行业未来"
        subTitle="基于品牌营销需求，再惠提供泛行业、多元化营销模式，助力商户提升营销效率，构筑私域流量池"
      />
      <ProductSection2
        className="section-1"
        title="品牌强曝光"
        subTitle="在传统外卖、本地生活平台视觉优化基础上，提供进一步竞价服务、高级
      NCPM 优化服务、新店宝推广、抢占热词流量等服务，第一时间获取平台
      信息同步，紧抓平台自然流量，高性价比提升 ROI"
        image={
          <div style={{ width: '568px' }}>
            <Img fluid={marketing0.childImageSharp.fluid} alt="品牌强曝光" />
          </div>
        }
      />
      {/* <ProductSection2
        className="section-2"
        type="row-reverse"
        title="全渠道触达"
        subTitle="覆盖传统营销渠道、微信朋友圈、小红书、微博等自媒体传播平台及各大短视频投放渠道，丰富多样的营销策略，为品牌获取更多公域、私域流量"
        image={
          <div style={{ width: '618px' }}>
            <Img fluid={marketing1.childImageSharp.fluid} alt="全渠道触达" />
          </div>
        }
      /> */}
      <ProductSection2
        className="section-3"
        title="营销自动化"
        subTitle="依托再惠大数据分析系统赋能，为商家推荐专业的会员管理决策，精准触达目标消费者，深度挖掘消费者需求。从会员拉新到促活营销来唤醒老客户等维度提出针对性决策，解决获客难题，提升用户转化"
        image={
          <div style={{ width: '522px' }}>
            <Img fluid={marketing2.childImageSharp.fluid} alt="营销自动化" />
          </div>
        }
      />
      <ProductSection2
        className="section-2"
        type="row-reverse"
        title="惠生活一站式权益卡"
        subTitle="惠生活权益卡是再惠集成3万家商户优惠券的同城权益服务包，帮助商户吸引商家头部用户，增强客户粘性"
        image={
          <div
            style={{
              width: '522px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              style={{ maxHeight: '424px' }}
              src={require('../../images/products/marketing/marketing-3.png')}
              alt="营销自动化"
            />
          </div>
        }
      />
      <HomeSection3 />
    </Layout>
  )
}

export default MarketingPage
